import { SetAllIcon } from './SetAllIcon';

/**
 * author: Simran
 * id 501D1421-A50E-470A-A05B-87864461C4ED
 * name set-all
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-all.svg
 * tags
 * - Database 
 */
export const SetUnionIcon = SetAllIcon;
export default SetUnionIcon